const About =()=>{
    return(
        <>
        <div id="video" class="basic-2">
            <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="image-container">
                        <div class="video-wrapper">
                            <a class="popup-youtube" href="https://www.youtube.com/watch?v=fLCjQJCekTs" data-effect="fadeIn">
                                <img class="img-fluid" src="images/video-image.png" alt="alternative" />
                                <span class="video-play-button">
                                    <span></span>
                                </span>
                            </a>
                        </div>
                    </div> 

                    <div class="p-heading">What better way to show off CoopXend app than presenting you some great situations of each module and features available to our users and customers in a video</div>        
                </div>
            </div>
        </div>
    </div>

        </>
    )
}

export default About;